export default __webpack_public_path__ + "static/media/portfolio-teamalert.636b2c0e.png";